module.exports = __webpack_public_path__ + "img/end_hand.411b80b7.png";